import { render, staticRenderFns } from "./MessageSent.vue?vue&type=template&id=03cb3752"
import script from "./MessageSent.vue?vue&type=script&lang=js"
export * from "./MessageSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports